import { useMemo, useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem } from '@mui/material';

export const RowMenu = ({ row, onOptionClickCallback, label }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = ({ currentTarget }) => {
    setAnchorEl(currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const isPrime = useMemo(() => {
    return row?.prime === 'true' || row?.prime === true;
  }, [row]);

  return (
    <>
      <MoreVertIcon onClick={openMenu} data-testid={`${label.toLowerCase()}-menu`} />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        slotProps={{
          paper: {
            sx: {
              width: '160px'
            }
          },
          list: {
            'aria-labelledby': 'basic-button'
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem
          onClick={() => {
            onOptionClickCallback([row.ssuPatientId]);
            handleCloseMenu();
          }}
          disabled={!!isPrime}
          data-testid={`${label.toLowerCase()}-menu-item`}
        >
          {label}
        </MenuItem>
      </Menu>
    </>
  );
};
